<template>
    <div class="content_module" style="background-color:#f9fafc;">
         <div class="back">WEINVENT</div>
         <div class="content" ref="content">
            <p class="title1">{{corporate_culture.name}}</p>
            <p class="title2">{{corporate_culture.value}}</p>
            <p class="title3"><span></span></p>
            <ul class='model'>
                <li v-for="item in corporate_culture.items">
                    <p class='title' ref="itemTitle"><img :src='item.img_src'/>{{item.title}}</p>
                    <p class='cont' ref="itemText">{{item.mes}}</p>
                </li>
            </ul>
            <ul class="cont_show" style="">
                <li class="img1" style="list-style:none;" v-for="item,key in corporate_culture.img_src" :key="key">
                    <img :src="item" />
                </li>
            </ul>
            <!-- swiper -->
            <div class='swiper-inner cont_show1'>
                <swiper :options="swiperOption">
                    <swiper-slide v-for="item,key in corporate_culture.img_src" :key="key">
                        <img style="width:100%;" :src="item" />
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <!-- 轮播图 
            <transition-group class="cont_img cont_show1" tag="ul" name="left">
                <li class="img1" v-for="item,key in corporate_culture.img_src" :key="key"  v-if="key === mark0">
                    <img :src="item" />
                </li>
            </transition-group>
            <transition-group class="cont_img center cont_show1" tag="ul" name="center">
                <li class="img2" v-for="item,key in corporate_culture.img_src" :key="key+100"  v-if="key === mark1">
                    <img :src="item" />
                </li>
            </transition-group>
            <transition-group class="cont_img cont_show1" tag="ul" name="right">
                <li class="img1" v-for="item,key in corporate_culture.img_src" :key="key+200"  v-if="key === mark2">
                    <img :src="item" />
                </li>
            </transition-group>
            -->
         </div>
    </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import {swiper,swiperSlide} from "vue-awesome-swiper";
export default {
  name: 'corporate-culture',
  props:['corporate_culture'],
  components:{
    swiper,
    swiperSlide
  },
  data () {
    return {
     mark0:0,
     mark1:1,
     mark2:2,
     //mark:[1,2,0],
     swiperOption: {
        loop:true,
        effect: 'coverflow',
        grabCursor: true,
        autoplay:{
            delay:3000,
            disableOnInteraction:false
        },
        centeredSlides: true,
        slidesPerView: 2,
        coverflowEffect: {
            rotate: 0,
            stretch:10,
            depth: 500,
            modifier: 2,
            slideShadows : false,
        },
        pagination: {
            el: '.swiper-pagination'
        },
     },
    }
  },
  mounted () {
    let self = this
    let rightReveal=self.$root.$data.rightReveal
    let leftReveal=self.$root.$data.leftReveal
    let topReveal=self.$root.$data.topReveal
    let fooReveal=self.$root.$data.fooReveal
    let fadeReveal=self.$root.$data.fadeReveal
    self.$scroll().reveal(self.$refs.itemTitle,fadeReveal)
    self.$scroll().reveal(self.$refs.itemText,{...fadeReveal,delay:700})
  //self.$scroll().reveal(self.$refs.imgLeft,{...leftReveal,scale:0.3})
  //self.$scroll().reveal(self.$refs.imgFoo,{...leftReveal,scale:0.6,distance:'80%'})
  //self.$scroll().reveal(self.$refs.imgRight,{...leftReveal,scale:1.5})
    console.log(self.$refs.content.clientWidth)
    if(self.$refs.content.clientWidth == 1200){
        self.interval=setInterval(function(){self.play()},3000);
    }
  },
  methods:{
    play(){
        let self= this
        //let k=self.mark[0]
        //self.mark[0] = self.mark[2]
        //self.mark[2] = self.mark[1]
        //self.mark[1] = k
        //console.log(self.mark)
        //self.mark0 = self.mark[0]
        //self.mark1 = self.mark[1]
        //self.mark2 = self.mark[2]
        //console.log(self.mark1)
    }
  },
    beforeDestroy () { 
        let self = this 
        self.$scroll().destroy()
        self.mywindow.clearInterval(self.interval)
}
}
</script>
<style scoped>
    .left-enter-active{
        transform:translateX(0);
        transition:all 1s ease;
    }
    .left-leave-active{
        transform:translateX(100%);
        transition:all 1s ease;
        z-index:-1;
        opacity:0;
    }
    .left-enter{
        transform:translateX(300%);
    }
    .left-leave{
        transform:translateX(100%);
    }
    .center-enter-active{
        transform:translateX(0);
        transition:all 1s ease;
    }
    .center-leave-active{
        transform:translateX(100%);
        transition:all 1s ease;
        z-index:-1;
        opacity:0;
    }
    .center-enter{
        transform:translateX(-100%) scale(0.5,0.5);
    }
    .center-leave{
        transform:translateX(100%);
    }
    .right-enter-active{
        transform:translateX(0);
        transition:all 1s ease;
    }
    .right-leave-active{
        transform:translateX(-100%);
        transition:all 1s ease;
        z-index:-1;
        opacity:0;
    }
    .right-enter{
        transform:translateX(-100%) scale(2,2);
    }
    .right-leave{
        transform:translateX(0);
    }
</style>
<style scoped>
@import '../../../static/css/common.css';

.swiper-inner {
    width: 100%;
    height: 560px;
    padding-top: 10px;
    padding-bottom: 50px;
}
.swiper-slide {
    background-position: center;
    background-size: cover;
    width: 600px;
    height: 500px;
}
.content{
    position:relative;
    padding-bottom:30px;
    display:flex;
    justify-content:center;
    flex-wrap:wrap;
}

.model{
    width:100%;
    margin-top:35px;
    display:flex;
    flex-wrap:wrap;
    margin-bottom:10px;
    justify-content:space-between;
}

.model li{
    display:inline-block;
    float:left;
    min-width:250px;
    flex:1 1 auto;
    list-style:none;
    margin-bottom:20px;
    position:relative;
}
.model li img{
    width:100%;
    height:100%;
}
.content>.model>li>.title{
    z-index:1;
    float:left;
    font-size:16px;
    color:#363636;
    width:100%;
    text-align:center;
    font-weight:600;
    line-height:20px;
}
.content>.model>li>.title>img{
    width:10px;
    height:auto;
    margin-right:.4em;
}
.content>.model>li>.cont{
    z-index:1;
    float:left;
    font-size:14px;
    color:#656464;
    width:100%;
    padding:0 15px;
    line-height:30px;
    text-align:center;
}
.cont_img{
    width:300px;
    overflow:hidden;
    height:500px;
    display:flex;
    align-items:center;
}
.cont_show{
    display:none;
}
.cont_show1{
    display:flex;
}
.center{
    width:600px;
    overflow:hidden;
    height:500px;
}
.cont_img li{
    width:100%;
    list-style:none;
    position:absolute;
}
li img{
    width:100%;
}
.img1{
    list-style:none;
    width:380px;
    background-color:#fff;
    margin-bottom:10px;
    display:flex;
    align-items:center;
}
.cont_img .img2{
    width:600px;
}
.cont_img .img3{
    width:300px;
}
</style>
<style scoped>
@media screen and (max-width: 1400px) {
    .cont_show{
        display:flex;
        width:100%;
        height:auto;
        flex-wrap:wrap;
        justify-content:center;
    }
    .cont_img .img1{
        width:60%;
        margin-bottom:20px;
    }
    .cont_img .img2{
        width:60%;
        margin-bottom:20px;
    }
    .cont_img .img3{
        width:60%;
    }
    .cont_show1{
        display:none;
    }
}
@media screen and (max-width: 655px) {
.cont_img .img1{
    width:60%;
    margin-bottom:20px;
}
.cont_img .img2{
    width:60%;
    margin-bottom:20px;
}
.cont_img .img3{
    width:60%;
}
    
}
</style>



// WEBPACK FOOTER //
// src/components/common/corporate_culture.vue